
import { useLocation } from 'react-router';
export default function BottomNav() {
    const location = useLocation();
    <nav className="navbar fixed-bottom navbar-light bg-blue">
        Footer <br />
        <label>Current Path: {location?.pathname + location.search}</label>
    </nav>
}